import { useEffect, useState } from 'react';
import { ListRow } from './ListRow';
import { ListSkeletonRows } from './ListSkeletonRows';
import { useListsContext } from '../../contexts';
import { LIST_SKELETON_ROW_COUNT } from '../../constants';

export const ListsTableRows = () => {
  const [rowCount, setRowCount] = useState(LIST_SKELETON_ROW_COUNT);
  const { isLoading, lists, totalSize } = useListsContext();

  useEffect(() => {
    if (!isLoading && totalSize) {
      setRowCount(totalSize);
    }
  }, [isLoading, totalSize, setRowCount]);

  const listsRows = lists.map((list) => <ListRow key={list.id} list={list} />);
  const listSkeletonRows = <ListSkeletonRows rowCount={rowCount} />;

  return <>{isLoading ? listSkeletonRows : listsRows}</>;
};
